module.exports = __webpack_public_path__ + "img/i_am_lord_voldemort.1b31c161.jpg";